/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import { injectable } from 'inversify'
import { ICoverageDiscoveryTransactionApiClient } from './contracts'
import { ICoverageDiscoveryTransaction } from '../CoverageDiscoveryTransactionStateManager/contracts'

@injectable()
export class MockCoverageDiscoveryTransactionApiClient implements ICoverageDiscoveryTransactionApiClient {
	public coverageDiscoveryTransaction: ICoverageDiscoveryTransaction = {
		id: 1,
		customerEntityId: 1,
		customerEntityFacilityId: 1,
		requestedByUserId: 1,
		batchTransactionTemplateId: 1,
		batchRunId: 1,
		payorLogicTransactionId: '1',
		statusId: 2,
		requestId: 1,
		responseId: 1,
		reviewed: false,
		reviewedByUserId: 0,
		reviewedDate: new Date('2020-12-09T13:36:25'),
		transactionRequest: {
			id: 1,
			requestDate: new Date('2020-12-09T13:36:25'),
			customerEntityId: 1,
			customerEntityFacilityId: 1,
			visitNumber: '12345',
			serviceBeginDate: new Date('2020-12-09T00:00:00'),
			serviceEndDate: new Date('2020-12-09T00:00:00'),
			individualId: 1,
			guarantorId: 1,
			requestMetaData: '',
			individual: {
				id: 1,
				customerEntityId: 1,
				masterIndividualId: 1,
				isMaster: false,
				masterPatientKey: '1',
				firstName: 'FirstName1',
				lastName: 'LastName1',
				middleName: 'MiddleName',
				gender: 'M',
				dateOfBirth: new Date('1994-12-09T00:00:00'),
				socialSecurityNumber: '123456789',
				socialSecurityNumberHashed: '123',
				address1: 'Address1',
				address2: 'Address2',
				city: 'City1',
				stateCodeId: '15',
				zip: '50024',
				phoneNumber: '9177541472',
				mrn: '123',
				clientId: '1',
				subscriberId: '1',
				deleted: false,
				stateCode: {
					id: 15,
					code: 'IN',
					name: 'Indiana',
					active: true,
				},
			},
		},
	}
	get(id: number): Promise<ICoverageDiscoveryTransaction> {
		return new Promise<ICoverageDiscoveryTransaction>(resolve => {
			resolve(this.coverageDiscoveryTransaction)
		})
	}
}
